// src/components/Loading/Loading.tsx
import React from 'react';

const Loading: React.FC = () => {
  return (
    <div >
      <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
    </div>
  );
};

export default Loading;
